import { BackofficeOrderDetail } from '@diamond/shared/types';
import { apiInstance } from '@diamond/shared/utils';

type GetActivityDetailByIdParams = {
  page: number;
  size: number;
};

const DEFAULT_PARAMS: GetActivityDetailByIdParams = {
  page: 1,
  size: 9999,
};

export async function getActivityDetailById(
  id: string,
  token: string,
  params: GetActivityDetailByIdParams = DEFAULT_PARAMS
): Promise<BackofficeOrderDetail> {
  const { data } = await apiInstance(token).get<BackofficeOrderDetail>(
    `/backoffice/order/${id}`,
    {
      params,
    }
  );

  return data;
}
